// @flow

import ko from 'rgs-knockout';

import { EventEmitter } from 'event-emitter';

import { events } from '../dictionary';

import type { ViewModelOptions, IViewModel } from '../contracts';

export default class ViewModel extends EventEmitter implements IViewModel {
	constructor (options: ViewModelOptions) {
		super();
		this._options = options;
		this._dataModel = options.dataModel;

		this.Phone = options.dataModel.Phone;
		this.Code = options.dataModel.Code;
		this.busy = options.busy;
		this.timer = options.timer;
		this.codeInputMask = '99999';
		this.hasSmsBeenSent = ko.observable(false);
	}

	get events () {
		return events;
	}
}